import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.modal.light,
    height: theme.spacing(11.25),
    justifyContent: 'center',
    alignItems: 'center',
  },

  title: {
    '&.MuiTypography-root': {
      fontSize: theme.spacing(3.75),
      fontFamily: '"Bebas Neue"',
      letterSpacing: '0.05em',
      lineHeight: 1,
      color: theme.palette.text.disabled,
    },
  },

  description: {
    '&.MuiTypography-root': {
      color: theme.palette.text.disabled,
    },
  },
}));
